import React from 'react';

interface LoadingScreenProps {
  message?: string;
}

export default function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="fixed inset-0 bg-white flex flex-col items-center justify-center z-50">
      <div className="flex flex-col items-center space-y-6">
        {/* Budgie Logo */}
        <div className="w-24 h-24 flex items-center justify-center">
          <img 
            src="/budgie_logo_sm.png" 
            alt="Budgie" 
            className="w-full h-full object-contain"
          />
        </div>
        
        {/* Green Spinner */}
        <div className="flex flex-col items-center space-y-3">
          <div className="relative">
            <div className="w-8 h-8 border-4 border-gray-200 border-t-green-500 rounded-full animate-spin"></div>
          </div>
          
          {/* Loading Text */}
          <p className="text-gray-600 font-medium text-sm">{message}</p>
        </div>
      </div>
    </div>
  );
} 